export enum GenderEnum {

  Maschile = 0,
  Femminile = 1

}
